// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"51":"ca03f63f","65":"fcf84c25","170":"aadea2c1","231":"2b7b07d8","288":"ebcc082d","661":"6796ee87","875":"6a6584ba"}[chunkId] + ".js";
};